const FIRST_BATTLE = require('./first_battle')

module.exports = {
    FIRST_BATTLE,
}
